<div class="container-fluid">
  <h4>{{'Summary.header' | translate}}</h4>
  @if (summaryNote !== '') {
    <div class="row">
      <div class="col-12 summaryNote" [innerHTML]="summaryNote"></div>
    </div>
  }
  <div class="mat-elevation-z8 mt-3">
    <div class="scrollableTable">
      <table mat-table [dataSource]="dataSource" >

        <!-- <ng-container matColumnDef="markets">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 50%;"> {{'Summary.thMarkets' | translate}}</th>
        <td mat-cell *matCellDef="let element"> <mat-label class="clickable" (click)="OnMarketClick(element.marketId)"> {{element.marketDescription}} </mat-label> </td>
      </ng-container>

      <ng-container matColumnDef="window">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"> {{'Summary.thWindow' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.conStartTime}} - {{element.conFinishTime}}</td>
      </ng-container>

      <ng-container matColumnDef="timeToOpen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'Summary.thTimeToOpen' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.timeToOpen}}</td>
      </ng-container>

      <ng-container matColumnDef="timeToClose">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'Summary.thTimeToClose' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.timeToClose}}</td>
      </ng-container> -->

      <ng-container matColumnDef="graph">
        <th mat-header-cell *matHeaderCellDef style="width: 60%;color: white; font-size: 16px;"> {{'Summary.thHistory' | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <h6 class="clickable" (click)="OnMarketClick(element.marketId)"> {{element.marketDescription}} </h6>
          @if (element.historyDataClient.length > 0) {
            <div style="width: 100%; height: 300px;" >
              <ngx-charts-line-chart style="text-align: center;"
                [scheme]="colorScheme"
                [legend]="true"
                [showXAxisLabel]="true"
                [showYAxisLabel]="true"
                [xAxis]="true"
                [yAxis]="true"
                [xAxisLabel]="'Date'"
                [yAxisLabel]="'Rate'"
                [timeline]="true"
                [results]="element.historyDataClient"
                [curve]="linearCurve"
                [legendTitle]="'Instruments'"
                >
              </ngx-charts-line-chart>
            </div>
          }
          @if (element.historyDataClient.length === 0) {
            <div  style="text-align: center;">
              <i>{{'Summary.noGraphData' | translate}}</i>
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef style="width: 40%;"> {{'Summary.thTiming' | translate}}</th>
        <td mat-cell *matCellDef="let element" style="vertical-align: top;">
          <!-- <div class="row">
          <div class="col-4">
            {{'Summary.thMarkets' | translate}}
          </div>
          <div class="col-8">
            <mat-label class="clickable" (click)="OnMarketClick(element.marketId)"> {{element.marketDescription}} </mat-label>
          </div>
        </div> -->
        <div class="row">
          <div class="col-4">
            <span style="font-weight: 600;">{{'Summary.thWindow' | translate}}</span>
          </div>
          <div class="col-8">
            {{element.conStartTime}} - {{element.conFinishTime}}
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <span style="font-weight: 600;">{{'Summary.thTimeToOpen' | translate}}</span>
          </div>
          <div class="col-8">
            {{element.timeToOpen}}
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <span style="font-weight: 600;">{{'Summary.thTimeToClose' | translate}}</span>
          </div>
          <div class="col-8">
            {{element.timeToClose}}
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="loading">
      <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
    </ng-container>

    <ng-container matColumnDef="noData">
      <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Summary.tblNoData' | translate}}... </th>
    </ng-container>

    <tr class="tableHeaderBgColor" mat-header-row *matHeaderRowDef="displayColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
    <tr mat-footer-row *matFooterRowDef="['noData']"
    [ngClass]="{'hide':(dataSource!=null && marketsLength != 0) || isLoading === true}"></tr>

  </table>
</div>
<!-- <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" [length]="marketsLength"></mat-paginator> -->
</div>
</div>